export default __webpack_public_path__ + "static/media/zoomIcon.1b130413.svg";